











































import DocumentLink from '@/components/DocumentLink'
import ContactBlock from '@/components/ContactBlock'

export default {
    name: 'FooterContactBlock'

    components:
        DocumentLink: DocumentLink

    extends: ContactBlock
}
